import apiService from "./ApiService"
import { createQS } from "./Utils"

class ComboService {
  async perfil() {
    try {
      return await apiService.get('combo/perfil')
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async empresa(idContrato = null) {
    try {
      const qs = createQS({ idContrato })
      return await apiService.get('combo/empresa?' + qs)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async consorcio() {
    try {
      return await apiService.get('combo/consorcio')
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async fiscal() {
    try {
      return await apiService.get('combo/fiscal')
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async gestor() {
    try {
      return await apiService.get('combo/gestor')
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async executor(idEmpresa) {
    try {
      const qs = createQS({ idEmpresa })
      return await apiService.get(`combo/executor?${qs}`)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async gestorContrato() {
    try {
      return await apiService.get('combo/gestor_contrato')
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async lote() {
    try {
      return await apiService.get('combo/lote')
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async usuario() {
    try {
      return await apiService.get('combo/usuario')
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async contrato() {
    try {
      return await apiService.get('combo/contrato')
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async aditivo(idContrato) {
    try {
      const qs = createQS({ idContrato })
      return await apiService.get(`combo/aditivo?${qs}`)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async municipio(uf = null) {
    try {
      const qs = createQS({ uf })
      return await apiService.get('combo/municipio?' + qs)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async veiculos(idEmpresa) {
    try {
      const qs = createQS({ idEmpresa })
      return await apiService.get(`combo/veiculo?${qs}`)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async equipes(idEmpresa) {
    try {
      const qs = createQS({ idEmpresa })
      return await apiService.get(`combo/equipe?${qs}`)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async cruzamento(idContrato) {
    try {
      const qs = createQS({ idContrato })
      return await apiService.get(`combo/cruzamento?${qs}`)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async tipoComponente() {
    try {
      return await apiService.get(`combo/tipo_componente`)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async modeloComponente(idTipoComponente) {
    try {
      const qs = createQS({ idTipoComponente })
      return await apiService.get(`combo/modelo_componente?${qs}`)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async tipoAnexoCruzamento() {
    try {
      return await apiService.get(`combo/tipo_anexo_cruzamento`)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async tipoProblema() {
    try {
      return await apiService.get(`combo/tipo_problema`)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async marca() {
    try {
      return await apiService.get(`combo/marca`)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }
}

const comboService = new ComboService()
export default comboService